/**
 * Even in plain mode the comment form serializes through its markdown writer, so what the
 * visitor typed as `**vet**` leaves as `\*\*vet\*\*` and the platform is asked a different
 * question than the one on screen (measured in the browser). This is the exact inverse of
 * a CommonMark backslash escape: only ASCII punctuation is ever escaped, and a typed `\`
 * arrives doubled, so a left-to-right pass restores the literal text.
 */
export function unescapeMarkdown(value: string): string {
  return value.replace(/\\([!-/:-@[-`{-~])/g, "$1");
}
